{
  "el": {
    "employee": {
      "actions": {
        "accessProjects": "Διαχείριση πρόσβασης σε έργα",
        "cancel": "Αναίρεση",
        "changeProfilePicture": "Αλλαγή φωτογραφίας προφίλ",
        "download": "Λήψη",
        "new": "Μέλος ομάδας",
        "profilePictureFormat": "Πρέπει να είναι τουλάχιστον 300x300px",
        "save": "Αποθήκευση",
        "searchEmployee": "Αναζήτηση μέλους ομάδας",
        "sendinvitation": "Δημιουργία και αποστολή πρόσκλησης",
        "submit": "Αποθήκευση",
        "undoChanges": "Αναίρεση"
      },
      "attributes": {
        "email_address": "Email",
        "email_notifications_interval": {
          "daily": "Μία φορά την ημέρα (γύρω στο μεσημέρι)",
          "hourly": "Κάθε ώρα",
          "twice_daily": "Δύο φορές την ημέρα (πρωί/μεσημέρι)",
          "weekly": "Μία φορά την εβδομάδα (Δευτέρα μεσημέρι)"
        },
        "first_name": "Όνομα",
        "language": "Γλώσσα",
        "last_name": "Επώνυμο",
        "phone_landline": "Αριθμός σταθερού τηλεφώνου",
        "phone_mobile": "Αριθμός κινητού τηλεφώνου",
        "profession": "Επάγγελμα",
        "role": "Δικαιώματα πρόσβασης",
        "signature_html": "Υπογραφή συνομιλιών",
        "status": "Κατάσταση",
        "title": "Τίτλος"
      },
      "billing": {
        "contact_us": "Επικοινωνήστε μαζί μας",
        "contact_us_message": "Γεια σας, θα ήθελα να αλλάξω το πακέτο του {client_name}.",
        "gigabytes": "{amount} GB",
        "in_use": "/ {total} σε χρήση",
        "manage_members": "Διαχείριση μελών",
        "package": "Πακέτο",
        "package_help_mup": "Χρειάζεστε επιπλέον έργα ή αποθηκευτικό χώρο, ή θέλετε να αλλάξετε πρόγραμμα;",
        "package_help_sup": "Χρειάζεστε επιπλέον έργα, θέσεις ή αποθηκευτικό χώρο, ή θέλετε να αλλάξετε πρόγραμμα;",
        "plan_renamed": "Έχουμε εισαγάγει νέα προγράμματα, οπότε το όνομα που εμφανίζεται εδώ μπορεί να μην αντιστοιχεί στην τρέχουσα συνδρομή σας. Επικοινωνήστε μαζί μας για να μάθετε περισσότερα για τα νέα προγράμματα.",
        "projects": "Έργα",
        "projects_available": "Όλα τα έργα σε χρήση | 1 έργο διαθέσιμο | {count} έργα διαθέσιμα",
        "seats": "Θέσεις",
        "seats_active": "/ {total} ενεργές",
        "seats_package": "Καμία θέση στο πακέτο σας | 1 θέση στο πακέτο σας | {count} θέσεις στο πακέτο σας",
        "seats_paying": "+ 1 επιπλέον πληρωμένη θέση | + {count} επιπλέον πληρωμένες θέσεις",
        "storage": "Αποθηκευτικός χώρος",
        "storage_available": "{amount} GB διαθέσιμα",
        "storage_total": "/ {amount} GB",
        "units": "Μονάδες",
        "units_available": "Όλες οι μονάδες σε χρήση | 1 μονάδα διαθέσιμη | {count} μονάδες διαθέσιμες"
      },
      "integrations": {
        "hide_details": "Απόκρυψη λεπτομερειών",
        "last_synced_at": "Τελευταίος συγχρονισμός: {time}",
        "show_details": "Εμφάνιση λεπτομερειών"
      },
      "labels": {
        "all_projects": "Όλα τα έργα",
        "confirmPasswordReset": "Στάλθηκε ένα email με σύνδεσμο επαναφοράς του κωδικού πρόσβασής σου. Έλεγξε τα εισερχόμενά σου. Επικοινώνησε μαζί μας αν αντιμετωπίσεις οποιοδήποτε πρόβλημα.",
        "disabled": {
          "access": "Θα δώσουμε πρόσβαση σε όλους τους υπαλλήλους στην πλατφόρμα από τη στιγμή που θα εξοφληθεί το τελευταίο ληξιπρόθεσμο τιμολόγιο.",
          "contact": "Επικοινώνησε μαζί μας",
          "overdue": "Παρατηρήσαμε ότι το τελευταίο σου τιμολόγιο είναι εδώ και καιρό ληξιπρόθεσμο. Ανακαλέσαμε την πρόσβαση όλων των υπαλλήλων σε αυτή την πλατφόρμα. Οι συνεργάτες και οι πελάτες θα εξακολουθήσουν να έχουν πρόσβαση στα δεδομένα τους.",
          "title": "Ο λογαριασμός σου έχει απενεργοποιηθεί"
        },
        "display": "Εμφάνιση",
        "filters": "Φίλτρα",
        "generalNotifications": "Να ειδοποιούμαι για",
        "has_access_to": "Έχει πρόσβαση σε",
        "information": "Πληροφορίες προφίλ",
        "informationNotificationsEmail": "Λάβε μια επισκόπηση μέσω email, που θα περιλαμβάνει μόνο τις ειδοποιήσεις που δεν έχεις δει ακόμα στην πλατφόρμα.",
        "informationNotificationsPlatform": "Λάβε όλες τις ειδοποιήσεις στην προσωπική σου επισκόπηση πάνω δεξιά στην οθόνη",
        "informationNotificationsTitle": "Επίλεξε τι είδους ειδοποιήσεις θέλεις να λαμβάνεις και πώς",
        "its_you!": "Είσαι εσύ",
        "maintainerAccess": "Πρόσβαση ανά έργο.",
        "name": "Όνομα",
        "onPlatform": "Στην πλατφόρμα",
        "ownerAccess": "Πρόσβαση σε όλα τα έργα και το περιεχόμενο, καθώς και στην τιμολόγηση και τη διαχείριση της ομάδας.",
        "password": "Κωδικός πρόσβασης",
        "permissions": "Δικαιώματα πρόσβασης για",
        "permissionsOwnerOnly": "Ο ρόλος Διαχειριστή έργου δεν επιτρέπει αυτή την ενέργεια. Ζήτησε από ένα μέλος της ομάδας {client_name} με ρόλο Ιδιοκτήτη να το κάνει για σένα.",
        "projectMaintains": "{first_name} έχει πρόσβαση στα παρακάτω έργα:",
        "projectMaintainsAdd": "Για να δώσεις πρόσβαση, επίλεξε ένα έργο και πρόσθεσε {first_name} ως Διαχειριστή έργου στην ενότητα Πληροφορίες.",
        "projectMaintainsNone": "δεν έχει πρόσβαση σε κανένα έργο.",
        "projectNotifications": "Για το έργο",
        "search_by_name_or_email": "Αναζήτηση με όνομα ή email",
        "show_signature": "Εμφάνιση υπογραφής",
        "signature_active": "Ενεργή υπογραφή",
        "signature_info": "Αυτή η υπογραφή θα προστίθεται στις απαντήσεις που στέλνονται σε πελάτες και συνεργάτες.",
        "sorting": "Ταξινόμηση",
        "viaEmail": "Μέσω email"
      },
      "modals": {
        "maintainers_access": {
          "accessible": "Προσβάσιμο",
          "description": "Οι αλλαγές αποθηκεύονται αυτόματα",
          "not_accessible": "Μη προσβάσιμο",
          "title": "Ενημέρωση προσβασιμότητας έργου για {first_name} {last_name}"
        }
      },
      "roles": {
        "maintainer": "Διαχειριστής έργου",
        "owner": "Ιδιοκτήτης"
      },
      "team": {
        "actions": {
          "activate": "Ενεργοποίηση",
          "cancel_invitation": "Ακύρωση πρόσκλησης",
          "deactivate": "Απενεργοποίηση",
          "invite": "Πρόσκληση",
          "make_maintainer": "Ορισμός ως διαχειριστή έργου",
          "make_owner": "Ορισμός ως ιδιοκτήτη",
          "remove": "Αφαίρεση από την ομάδα"
        },
        "dialogs": {
          "activate_body": "Ο/Η {name} αποκτά ξανά πλήρη πρόσβαση στην πλατφόρμα.",
          "activate_body_pending": "Ο/Η {name} επιστρέφει στην κατάσταση «Σε αναμονή» και γίνεται ενεργός/ή μόλις συνδεθεί με την πρόσκλησή του/της.",
          "activate_body_seat": "Ο/Η {name} αποκτά ξανά πλήρη πρόσβαση στην πλατφόρμα. Αυτό χρησιμοποιεί μία θέση.",
          "activate_confirm": "Ενεργοποίηση",
          "activate_title": "Ενεργοποίηση του/της {name};",
          "cancel_invitation_body": "Ο/Η {name} δεν μπορεί πλέον να συμμετάσχει με την πρόσκληση που έλαβε.",
          "cancel_invitation_confirm": "Ακύρωση πρόσκλησης",
          "cancel_invitation_title": "Ακύρωση πρόσκλησης;",
          "contact_us": "Επικοινωνήστε μαζί μας",
          "contact_us_message": "Γεια σας, θα ήθελα να προσθέσω περισσότερες θέσεις για τον οργανισμό {client_name}.",
          "deactivate_body": "Ο/Η {name} κρατά τον λογαριασμό αλλά χάνει την πρόσβαση στην πλατφόρμα.",
          "deactivate_body_seat": "Ο/Η {name} κρατά τον λογαριασμό αλλά χάνει την πρόσβαση στην πλατφόρμα. Αυτό απελευθερώνει μία θέση.",
          "deactivate_confirm": "Απενεργοποίηση",
          "deactivate_title": "Απενεργοποίηση του/της {name};",
          "demote_body": "Ο/Η {name} χάνει την πρόσβαση σε όλα τα έργα μέχρι να του/της τη δώσετε, και δεν μπορεί πλέον να διαχειρίζεται την τιμολόγηση ή την ομάδα.",
          "demote_confirm": "Ορισμός ως διαχειριστή έργου",
          "demote_title": "Ορισμός του/της {name} ως διαχειριστή έργου;",
          "owner_wall_banner": "Ο οργανισμός σας πρέπει πάντα να έχει τουλάχιστον έναν ενεργό ιδιοκτήτη.",
          "owner_wall_body_deactivate": "Ενεργοποιήστε ξανά ή προωθήστε άλλον ιδιοκτήτη πριν απενεργοποιήσετε τον/την {name}.",
          "owner_wall_body_demote": "Ενεργοποιήστε ξανά ή προωθήστε άλλον ιδιοκτήτη πριν αλλάξετε τον ρόλο του/της {name}.",
          "owner_wall_body_remove": "Ενεργοποιήστε ξανά ή προωθήστε άλλον ιδιοκτήτη πριν αφαιρέσετε τον/την {name}.",
          "owner_wall_title": "Η ενέργεια αποκλείστηκε",
          "promote_body": "Ο/Η {name} αποκτά πρόσβαση σε όλα τα έργα και μπορεί να διαχειρίζεται την τιμολόγηση και την ομάδα.",
          "promote_confirm": "Ορισμός ως ιδιοκτήτη",
          "promote_title": "Ορισμός του/της {name} ως ιδιοκτήτη;",
          "remove_body": "Ο/Η {name} χάνει την πρόσβαση και φεύγει από τη λίστα μελών. Αυτό δεν αναιρείται, αλλά μπορείτε να τον/την προσκαλέσετε ξανά αργότερα.",
          "remove_body_seat": "Ο/Η {name} χάνει την πρόσβαση και φεύγει από τη λίστα μελών. Αυτό δεν αναιρείται, αλλά μπορείτε να τον/την προσκαλέσετε ξανά αργότερα. Αυτό απελευθερώνει μία θέση.",
          "remove_confirm": "Αφαίρεση",
          "remove_title": "Αφαίρεση του/της {name} από την ομάδα;",
          "seats_full_banner": "Η μοναδική σας θέση χρησιμοποιείται. | Και οι {total} θέσεις χρησιμοποιούνται.",
          "seats_full_body": "Απενεργοποιήστε ένα ενεργό μέλος για να ελευθερωθεί μια θέση, ή επικοινωνήστε μαζί μας για περισσότερες θέσεις.",
          "seats_full_invite_body": "Χρειάζεστε μια διαθέσιμη θέση για να προσκαλέσετε κάποιον. Απενεργοποιήστε ένα ενεργό μέλος, ή επικοινωνήστε μαζί μας για περισσότερες θέσεις.",
          "seats_full_invite_title": "Δεν έχετε άλλες θέσεις",
          "seats_full_title": "Δεν υπάρχουν διαθέσιμες θέσεις"
        },
        "invite_incomplete": "Συμπληρώστε όνομα, επώνυμο και email για να στείλετε την πρόσκληση.",
        "invite_note": "Γίνονται ενεργοί μόλις δημιουργήσουν λογαριασμό και συνδεθούν.",
        "invite_note_seats": "Μόλις δημιουργήσουν λογαριασμό και συνδεθούν, γίνονται ενεργοί και χρησιμοποιούν την τελευταία διαθέσιμη θέση σας. | Μόλις δημιουργήσουν λογαριασμό και συνδεθούν, γίνονται ενεργοί και χρησιμοποιούν μία από τις {count} διαθέσιμες θέσεις σας.",
        "invite_sent": "Η πρόσκληση στάλθηκε",
        "invited_at": "Προσκλήθηκε: {when}",
        "last_active": "Τελευταία δραστηριότητα",
        "manage_in_billing": "Διαχείριση στην Τιμολόγηση",
        "resend_wait": "Μπορείτε να στείλετε ξανά την πρόσκληση 15 λεπτά μετά την προηγούμενη.",
        "role": "Ρόλος",
        "seat_states": "Καταστάσεις θέσεων",
        "seat_states_help": {
          "active": "Πλήρης πρόσβαση, χρησιμοποιεί μία θέση. Ιδιοκτήτες και διαχειριστές έργου.",
          "inactive": "Ο λογαριασμός υπάρχει, χωρίς πρόσβαση στην πλατφόρμα. Απελευθερώνει τη θέση.",
          "pending": "Προσκεκλημένος, χωρίς λογαριασμό ακόμα. Δεν χρησιμοποιεί θέση."
        },
        "seat_usage": "Χρήση θέσεων",
        "seats_available": "Δεν υπάρχουν διαθέσιμες θέσεις - απενεργοποιήστε ένα μέλος ή επικοινωνήστε μαζί μας | 1 διαθέσιμη θέση | {count} διαθέσιμες θέσεις",
        "seats_rule": "Μόνο ένας ιδιοκτήτης μπορεί να ενεργοποιήσει ένα μέλος, και μόνο όσο υπάρχει διαθέσιμη θέση.",
        "seats_total": "/ {total} ενεργή θέση | / {total} ενεργές θέσεις",
        "statuses": {
          "active": "Ενεργός",
          "inactive": "Ανενεργός",
          "pending": "Σε αναμονή"
        }
      },
      "toasts": {
        "create": "Το μέλος ομάδας δημιουργήθηκε",
        "update": "Το μέλος ομάδας ενημερώθηκε"
      },
      "validation": {
        "emailTaken": "Η διεύθυνση email χρησιμοποιείται ήδη",
        "mustBeEmailAddress": "Απαιτείται έγκυρη διεύθυνση email",
        "needFirstName": "Το όνομα είναι υποχρεωτικό",
        "needLastName": "Το επώνυμο είναι υποχρεωτικό",
        "requireEmailAddress": "Το email είναι υποχρεωτικό",
        "role": "Επίλεξε δικαιώματα πρόσβασης"
      }
    }
  }
}
